import React from "react";
import "./StylePreview.css";

export default function StylePreview(props) {
  return (
    <div className="style-preview-wrapper">
      <h3>{props.title}</h3>
      <div
        className="pw-bg"
        style={{ backgroundColor: props.background }}
      >
        <div
          className="pw-nav-bar"
          style={{
            backgroundColor: props.navigation,
            fontFamily: props.paragraph,
            color: props.nvbarText || "#000",
          }}
        >
          <div
            className="pw-nav-items"
            style={{ color: props.nvbarText || "#000" }}
          >
            <span>Home</span>
            <span>Blogs</span>
            <span>Contact</span>
          </div>
          <button
            className="pw-nav-button"
            style={{
              backgroundColor: props.button,
              color: props.nvbarText,
              fontFamily: props.paragraph,
            }}
          >
            Book Now
          </button>
        </div>

        <hr className="pw-divider" />
        <div className="pw-heading">
          <h3 style={{ fontFamily: props.heading, color: props.webTheme }}>
            Lorem Ipsum
          </h3>
        </div>
        <div
          className="pw-button"
          style={{ backgroundColor: props.button }}
        ></div>
        <div className="pw-paragraph">
          <p style={{ fontFamily: props.paragraph }}>{props.sample2}</p>
        </div>
        <div
          className="pw-footer"
          style={{ color: props.nvbarText, fontFamily: props.paragraph }}
        >
          <div className="pw-footer-col">
            <h3 style={{ fontFamily: props.heading, color: props.webTheme }}>Your Brand</h3>
            <button
              className="pw-footer-button"
              style={{ backgroundColor: props.button, fontFamily: props.paragraph }}
            >
              Log in as admin
            </button>
          </div>

          <div className="pw-footer-col">
            <h3 style={{ fontFamily: props.heading, color: props.webTheme }}>Page</h3>
            <p>Home</p>
            <p>Blogs</p>
            <p>Contact</p>
          </div>

          <div className="pw-footer-col">
            <h3 style={{ fontFamily: props.heading, color: props.webTheme }}>About</h3>
            <p>📞 0123</p>
            <p>✉️ email</p>
            <p>📍 location</p>
          </div>
        </div>
      </div>
    </div>
  );
}
